/* eslint-disable react/jsx-props-no-spreading */
import { bool, func, shape, string } from "prop-types";
import { useRef } from "react";
import { useDispatch } from "react-redux";

import __ from "web/Layout/Translations";

import urls from "web/constants/urls";

import {
  openNavigation,
  resetLastNavigationUrl,
} from "web/features/app/appSlice";

import useLongPress from "../../../hooks/useLongPress";

const PanelItemNavigation = ({
  classes,
  item,
  pathname,
  pageType,
  isNavigationOpened,
}) => {
  const dispatch = useDispatch();
  const clickCount = useRef(0);
  const singleClickTimer = useRef(null);
  const { name, icon: Icon } = item;
  const isActive =
    isNavigationOpened ||
    !pathname.indexOf(urls.search) ||
    !pathname.indexOf(urls.tourism) ||
    pageType === "PRODUCT" ||
    pageType === "CATEGORY";
  const classNameRoot = isActive
    ? `${classes.root} ${classes.rootActive}`
    : classes.root;
  const onClickHandler = () => {
    clickCount.current += 1;
    if (clickCount.current <= 1) {
      singleClickTimer.current = setTimeout(() => {
        clickCount.current = 0;
        dispatch(openNavigation());
      }, 300);
    } else {
      clearTimeout(singleClickTimer.current);
      clickCount.current = 0;
      dispatch(resetLastNavigationUrl());
      dispatch(openNavigation());
    }
  };

  const longPressEvent = useLongPress(() => {
    dispatch(resetLastNavigationUrl());
    dispatch(openNavigation());
  }, onClickHandler);

  return (
    <div className={classNameRoot}>
      <a
        {...longPressEvent}
        className={classes.link}
        title={__(name)}
        data-t1="panel_item_link"
        data-t2={name}
      >
        <span className={classes.iconBox}>
          <Icon className={classes.icon} />
        </span>
      </a>
    </div>
  );
};

PanelItemNavigation.propTypes = {
  item: shape({}).isRequired,
  classes: shape({}).isRequired,
  pageType: string.isRequired,
  pathname: string.isRequired,
  closeAction: func,
  isNavigationOpened: bool.isRequired,
};

PanelItemNavigation.defaultProps = {
  closeAction: () => {},
};

export default PanelItemNavigation;
